import { forwardRef } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { Avatar, AvatarProps } from '@material-ui/core';

// ----------------------------------------------------------------------

type AvatarColor =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'info'
  | 'success'
  | 'warning'
  | 'error';

// ----------------------------------------------------------------------

export interface MAvatarProps extends AvatarProps {
  color?: AvatarColor;
}

const MAvatar = forwardRef<HTMLDivElement, MAvatarProps>(
  ({ color = 'default', children, sx, ...other }, ref) => {
    const theme = useTheme();
    const { src } = other;
    if (color === 'default') {
      return (
        <Avatar src={src} ref={ref} sx={sx} {...other}>
          {/* SUP
          {children} */}
        </Avatar>
      );
    }

    return (
      <Avatar
        ref={ref}
        sx={{
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette[color].contrastText,
          backgroundColor: theme.palette[color].main,
          ...sx
        }}
        {...other}
      >
        {children}
      </Avatar>
    );
  }
);

export default MAvatar;
